module.exports = __webpack_public_path__ + "static/scale-model-of-rancho-san-rafael-regional-park-in-reno-nevada-34d0265b3162afeded88631f4558d5ef.png";